import React from "react";
import { useTranslation } from "react-i18next";
import Violation from "license/LicenseState/Violation";
const LicenseState = ({ violations, version = void 0, evaluated = true }) => {
  const { t } = useTranslation("enterprise_license");
  const versionMissingViolation = "version_missing";
  const violationsMap = {
    violated: {
      severity: "warning",
      text: t("license.state.violated")
    },
    expired: {
      severity: "warning",
      text: t("license.state.expired")
    },
    cluster_not_covered: {
      severity: "info",
      text: t("license.state.cluster_not_covered")
    },
    nodes_exceeded: {
      severity: "info",
      text: { 1: t("license.state.nodes_exceeded") }
    },
    traffic_exceeded: {
      severity: "info",
      text: {
        2: t("license.state.traffic_exceeded_daily"),
        3: t("license.state.traffic_exceeded_volume"),
        4: t("license.state.traffic_exceeded_daily")
      }
    },
    remote_checks_failed: {
      severity: "info",
      text: {
        2: t("license.state.remote_checks_failed"),
        4: t("license.state.remote_checks_failed")
      }
    },
    version_missing: {
      severity: "info",
      text: t("license.details.unknown_version")
    }
  };
  const genericViolations = ["violated", "expired", "cluster_not_covered"];
  const versionDependantViolations = {
    1: ["nodes_exceeded"],
    2: ["traffic_exceeded", "remote_checks_failed"],
    3: ["traffic_exceeded"],
    4: ["traffic_exceeded", "remote_checks_failed"]
  };
  const violatedViolations = () => {
    const violatedGenericViolations = genericViolations.filter((violationName) => violations[violationName] === true);
    if (!version) {
      return [...violatedGenericViolations, versionMissingViolation];
    }
    const violatedVersionDependantViolations = versionDependantViolations[version].filter(
      (violationName) => violations[violationName] === true
    );
    return [...violatedGenericViolations, ...violatedVersionDependantViolations];
  };
  const findings = violatedViolations();
  const hasRealFinding = findings.some((finding) => finding !== versionMissingViolation);
  if (!evaluated && !hasRealFinding) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, t("license.list.not_applicable"));
  }
  if (findings.length < 1) {
    return /* @__PURE__ */ React.createElement(Violation, { text: t("license.state.no_problems") });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, findings.map((violation) => {
    var _a;
    const violationText = (_a = violationsMap[violation]) == null ? void 0 : _a.text;
    if (typeof violationText === "string") {
      return /* @__PURE__ */ React.createElement(Violation, { key: violation, text: violationText, severity: violationsMap[violation].severity });
    }
    return /* @__PURE__ */ React.createElement(Violation, { key: violation, text: violationText[version], severity: violationsMap[violation].severity });
  }));
};
export default LicenseState;
